"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _planout = _interopRequireDefault(require("planout"));

var LabSetup = _interopRequireWildcard(require("hublabs-core/setup/LabSetup"));

var _default = {
  getStoredLabsID: LabSetup.getUserId,
  registerUser: LabSetup.registerUser,
  setParam: _planout.default.ExperimentSetup.registerExperimentInput
};
exports.default = _default;
module.exports = exports.default;